export const toursCommandCentreQueryKeys = {
  all: ['reporting', 'tours-command-centre'] as const,
};
